import { render, staticRenderFns } from "./procedimientos-evidencia-ver.vue?vue&type=template&id=74c5576c&scoped=true&"
import script from "./procedimientos-evidencia-ver.vue?vue&type=script&lang=js&"
export * from "./procedimientos-evidencia-ver.vue?vue&type=script&lang=js&"
import style0 from "./procedimientos-evidencia-ver.vue?vue&type=style&index=0&id=74c5576c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c5576c",
  null
  
)

export default component.exports